export const TestEquipmentTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "EQUIPO (NOMBRE, MODELO, FABRICANTE)",
                    type: 'text',
                    key: 'equipment',

                },
                {
                    title: "RANGO, CAPACIDAD Y OTRA INFORMACIÓN IMPORTANTE",
                    type: 'text',
                    key: 'description',

                },
                {
                    title: "FECHA DE PUESTA EN SERVICIO Y ULTIMA CALIBRACIÓN",
                    type: 'text',
                    key: 'date_service',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}